import { Box, Text } from "@chakra-ui/react";
import React, { Suspense, lazy } from "react";

const TuteriaLogo = lazy(() => import("../../assets/logo/TuteriaLogo"));

export const ErrorPage = () => {
  return (
    <Box
      mt="0.3rem"
      background={"#fff"}
      maxW={"600px"}
      px={"25px"}
      py={"4rem"}
      mx="auto"
      display={"flex"}
    >
      <Box>
        <Suspense fallback={<div>Loading...</div>}>
          <TuteriaLogo w={"150px"} mb="5rem" />
        </Suspense>
        <Text fontSize={"2rem"} fontWeight="bold">
          Oops! We ran into a problem
        </Text>
        <Text mt={"2rem"}>
          Something went wrong on our end. Please try again later or contact
          support if the issue persists.
        </Text>
      </Box>
    </Box>
  );
};
